import React, { createContext, useState, useContext } from 'react';

// 1. Create the Context
const UserContext = createContext();

// 2. Create the Provider Component
const UserProvider = ({ children }) => {
    const [selectedLoginUser, setSelectedLoginUser] = useState({
        label: "Select Dealer",
        value: 0,
      });

  return (
    <UserContext.Provider value={{ selectedLoginUser, setSelectedLoginUser }}>
      {children}
    </UserContext.Provider>
  );
};

// 3. Custom Hook (optional but recommended)
const useUser = () => {
  return useContext(UserContext);
};

export { UserProvider, useUser };
